import * as __ext0 from "react";
import * as __ext1 from "react-dom";
import * as __ext2 from "react/jsx-runtime";
import * as __ext3 from "react-router-dom";
var require = (m) => {
  var __mods = {
    "react": __ext0,
    "react-dom": __ext1,
    "react/jsx-runtime": __ext2,
    "react-router-dom": __ext3,
  };
  if (__mods[m]) return __mods[m];
  throw new Error("Cannot require " + m);
};
import{jsx as i}from"react/jsx-runtime";var e={default:"https://cdn.prod.website-files.com/646226ec552e56d4f1caaa20/656970f534417e587ec38843_256by256.png"};function c({variant:a="default",className:r,width:t,height:o,alt:n="Snakker logo"}){let s=e[a]??e.default;return i("img",{src:s,alt:n,className:r,width:t,height:o,style:{objectFit:"contain",width:t,height:o},"data-id":"element-50","data-mp":"1vgzdnat1d0c7"})}export{c as Logo};
//# sourceMappingURL=library.js.map
